import { Box, Typography } from '@mui/material';
import React from 'react';

export interface InfoCardSubjectTitleProps {
  children: React.ReactNode;
}

/**
 * InfoCardSubjectTitle renders the non-shrinking title in an info card header.
 * @param props - Title content.
 * @returns A typography title element.
 */
export const InfoCardSubjectTitle = ({
  children,
}: InfoCardSubjectTitleProps) => (
  <Box component={Typography} flexShrink={0} variant="titleMedium">
    {children}
  </Box>
);
